import { createRoute, redirect } from "@tanstack/solid-router";
import { appRoute } from "./route";

/**
 * Landing de Space: redirige a "Aprender" (`/learn`). El dashboard de listas del
 * template quedó retirado con la contracción del dominio todo.
 */
export const indexRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/",
  beforeLoad: ({ params }) => {
    // oxlint-disable-next-line @typescript-eslint/only-throw-error
    throw redirect({ to: "/u/$u/learn", params: { u: params.u }, replace: true });
  },
  component: () => null,
});
